import styled from "styled-components";

import {
  Stack,
  TextField,
  Grid,
  Box,
  IconButton,
  Checkbox,
  Autocomplete,
  createFilterOptions,
  FormHelperText,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import CameraIcon from "src/components/icon/Camera";
import CropIcon from "@mui/icons-material/Crop";

import BlogCard from "src/components/blog/BlogCard";
import ImageCropperModal from "./ImageCropper/ImageCropperModal";

import font from "src/styles/font";
import { UseUpload } from "src/context/UploadProductContext";
import { forwardRef } from "react";

import { useDialog } from "src/context/DialogContext";

const S = {};

S.Container = styled.div`
  width: 100%;
  margin: 0 auto;
  margin-top: 24px;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

// S.UploadSectionWrapper = styled.div`
//   display: grid;
//   grid-template-columns: repeat(12, 1fr);
//   gap: 24px;
//   margin-top: 16px;
// `;

S.BannerImageUploadBox = styled.div`
  position: relative;
  padding-top: calc(100% / (1440 / 472));
  background-color: #f3f1f2;
  border-radius: 24px;
  /* grid-column: span 12; */
`;

S.BlogPreview = styled.div`
  border: 3px dashed #f3f1f2;
  border-radius: 24px;
  padding: 24px;
  height: fit-content;
  /* grid-column: span 5; */
`;

S.PreviewImageUploadBox = styled.div`
  position: relative;
  padding-top: 100%;
  background-color: #f3f1f2;
  border-radius: 24px;
  /* grid-column: span 7; */
`;

S.UploadInnerBox = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

S.UploadInput = styled.label`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
`;

S.UploadLabel = styled.span`
  font-size: ${font.size.md};
  font-weight: bold;
  color: #6c6c70;
  margin-top: 16px;

  &::after {
    content: "*";
    font-weight: 600;
    color: #e04132;
  }
`;

S.UploadHelperText = styled.span`
  display: flex;
  justify-content: center;
  font-size: ${font.size.sm};
  color: #6c6c70;
  margin-top: 8px;
`;

S.UploadedPreviewImage = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 15px;
  object-fit: cover;
`;

const Step1 = ({ formErrors, formData, onChange }) => {
  const { openDialog, closeDialog } = useDialog();

  const { masterdata } = UseUpload();

  const sortHashtag = masterdata.hashtag_data.sort((a, b) => {
    return b.blog_count - a.blog_count;
  });

  return (
    <S.Container>
      <label style={{ fontSize: font.size.lg }}>ข้อมูลที่แสดงบนการ์ด</label>

      <Grid
        container
        spacing={3}
        sx={{
          mt: 2,
        }}
      >
        <Grid item xs={12}>
          <S.BannerImageUploadBox>
            {!formData.banner_image ? (
              <S.UploadInnerBox>
                <Stack flexDirection={"row"}>
                  <input
                    id="bannerImgFieldHandle"
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    style={{ display: "none" }}
                    onChange={(e) => {
                      e.preventDefault();
                      onChange(null, "banner_image", e.target.files[0]);
                    }}
                    onClick={(e) => (e.currentTarget.value = null)}
                  />
                  <S.UploadInput htmlFor="bannerImgFieldHandle">
                    <CameraIcon size={60} color="#BCBCC0" />
                    <S.UploadLabel>อัพโหลดภาพแบนเนอร์</S.UploadLabel>
                    <S.UploadHelperText>
                      รูปภาพขนาด 1440 X 472 Pixel ขนาดไฟล์สูงสุดไม่เกิน 2 MB
                    </S.UploadHelperText>
                  </S.UploadInput>
                </Stack>
              </S.UploadInnerBox>
            ) : (
              <>
                <S.UploadedPreviewImage
                  src={
                    typeof formData.banner_image === "string"
                      ? formData.banner_image
                      : URL.createObjectURL(formData.banner_image)
                  }
                  alt=""
                />
                <Stack
                  sx={{
                    position: "absolute",
                    top: 6,
                    right: 6,
                  }}
                  flexDirection={"row"}
                  columnGap={1}
                >
                  <IconButton
                    sx={{
                      padding: "4px",
                      backgroundColor: "#BCBCC0bd",
                    }}
                    onClick={() => {
                      openDialog({
                        type: "custom",
                        customDialog: (
                          <ImageCropperModal
                            aspectRatio={1440 / 472}
                            imageData={formData.banner_image}
                            onClose={() => closeDialog()}
                            onSubmit={(val) => {
                              onChange(null, "banner_image", val);
                              closeDialog();
                            }}
                          />
                        ),
                      });
                    }}
                  >
                    <CropIcon sx={{ color: "#ffffff" }} />
                  </IconButton>
                  <IconButton
                    sx={{
                      padding: "4px",
                      backgroundColor: "#BCBCC0bd",
                    }}
                    onClick={() => {
                      onChange(null, `banner_image`, null);
                    }}
                  >
                    <CloseIcon sx={{ color: "#ffffff" }} />
                  </IconButton>
                </Stack>
              </>
            )}
          </S.BannerImageUploadBox>
          {formErrors[`banner_image`] && (
            <FormHelperText error={!!formErrors[`banner_image`]}>
              กรุณาเลือกรูปภาพแบนเนอร์
            </FormHelperText>
          )}
        </Grid>
        <Grid item xs={5}>
          <S.BlogPreview>
            <BlogCard
              title={
                formData?.title ||
                //   "Lorem Ipsum is simply dummy text of the printing a"
                "Example Title"
              }
              excerpt={
                formData?.sub_title ||
                //   "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the "
                "Example Sub Title"
              }
              tags={formData?.hashtags.slice(0, 3)}
              image={
                formData?.preview_image
                  ? typeof formData.preview_image === "string"
                    ? formData.preview_image
                    : URL.createObjectURL(formData.preview_image)
                  : ""
              }
            />
          </S.BlogPreview>
        </Grid>
        <Grid item xs={7}>
          <S.PreviewImageUploadBox>
            {!formData.preview_image ? (
              <S.UploadInnerBox>
                <Stack flexDirection={"row"}>
                  <input
                    id="previewImgFieldHandle"
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    style={{ display: "none" }}
                    onChange={(e) => {
                      e.preventDefault();
                      onChange(null, "preview_image", e.target.files[0]);
                    }}
                    onClick={(e) => (e.currentTarget.value = null)}
                  />
                  <S.UploadInput htmlFor="previewImgFieldHandle">
                    <CameraIcon size={60} color="#BCBCC0" />
                    <S.UploadLabel>อัพโหลดภาพหน้าปก</S.UploadLabel>
                    <S.UploadHelperText>
                      รูปภาพขนาด 500 X 500 Pixel ขนาดไฟล์สูงสุดไม่เกิน 2 MB
                    </S.UploadHelperText>
                  </S.UploadInput>
                </Stack>
              </S.UploadInnerBox>
            ) : (
              <>
                <S.UploadedPreviewImage
                  src={
                    typeof formData.preview_image === "string"
                      ? formData.preview_image
                      : URL.createObjectURL(formData.preview_image)
                  }
                  alt=""
                />
                <Stack
                  sx={{
                    position: "absolute",
                    top: 6,
                    right: 6,
                  }}
                  flexDirection={"row"}
                  columnGap={1}
                >
                  <IconButton
                    sx={{
                      padding: "4px",
                      backgroundColor: "#BCBCC0bd",
                    }}
                    onClick={() => {
                      openDialog({
                        type: "custom",
                        customDialog: (
                          <ImageCropperModal
                            aspectRatio={1}
                            imageData={formData.preview_image}
                            onClose={() => closeDialog()}
                            onSubmit={(val) => {
                              onChange(null, "preview_image", val);
                              closeDialog();
                            }}
                          />
                        ),
                      });
                    }}
                  >
                    <CropIcon sx={{ color: "#ffffff" }} />
                  </IconButton>
                  <IconButton
                    sx={{
                      padding: "4px",
                      backgroundColor: "#BCBCC0bd",
                    }}
                    onClick={() => {
                      onChange(null, `preview_image`, null);
                    }}
                  >
                    <CloseIcon sx={{ color: "#ffffff" }} />
                  </IconButton>
                </Stack>
              </>
            )}
          </S.PreviewImageUploadBox>
          {formErrors[`preview_image`] && (
            <FormHelperText error={!!formErrors[`preview_image`]}>
              กรุณาเลือกรูปภาพหน้าปก
            </FormHelperText>
          )}
        </Grid>
      </Grid>

      <Grid
        container
        spacing={2.5}
        sx={{
          mt: 2,
        }}
      >
        <Grid item xs={12}>
          <Autocomplete
            id="combo-box-hashtag"
            fullWidth
            multiple
            // options={masterdata.hashtag_data.map((tags) => ({ name: tags.name }))}
            options={sortHashtag}
            getOptionLabel={(option) => {
              // if (option.name.includes("#")) {
              //   return option.name;
              // }
              return `#${option.name}`;
            }}
            value={formData?.hashtags}
            isOptionEqualToValue={(option, value) => option.name === value.name}
            onChange={(e, value) => {
              if (formData?.hashtags.length > 1 && value.length === 0) {
                openDialog({
                  type: "confirm",
                  title: "คุณต้องการลบแฮชแท็กทั้งหมดใช่หรือไม่?",
                  onConfirm: () => {
                    onChange(e, `hashtags`, value);
                    closeDialog();
                  },
                  maxWidth: 342,
                });
              } else {
                onChange(e, `hashtags`, value);
              }
            }}
            freeSolo
            disableCloseOnSelect
            ListboxComponent={forwardRef(
              ({ children, index, ...props }, ref) => (
                <ul
                  {...props}
                  ref={ref}
                  key={`list-${index}`}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexWrap: "wrap",
                  }}
                >
                  {children}
                </ul>
              ),
            )}
            renderOption={(props, option, { selected }, index) => (
              <>
                <li
                  {...props}
                  key={`hashtag-option-${index}`}
                  style={{
                    flex: "0 0 25%",
                    maxWidth: "25%",
                    flexWrap: "wrap",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Checkbox
                      sx={{
                        "&.Mui-checked": {
                          color: "#E13B30",
                        },
                      }}
                      checked={selected}
                    />
                    {option.name}
                  </div>
                  <p
                    style={{
                      width: "100%",
                      margin: 0,
                      fontSize: "0.75rem",
                      color: "#6C6C70",
                      paddingLeft: "40px",
                    }}
                  >
                    ถูกใช้ไปแล้ว {option.blog_count} ครั้ง
                  </p>
                </li>
              </>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="#Hashtag"
                error={!!formErrors[`hashtags`]}
                helperText={
                  !!formErrors[`hashtags`] ? (
                    "กรุณาเลือกแฮชแท็ก"
                  ) : (
                    <Box sx={{ height: "20px" }} />
                  )
                }
              />
            )}
            style={{
              width: "100%",
              borderRadius: "16px",
              // marginBottom: "20px",

              ".MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root": {
                borderRadius: "16px",
              },
            }}
            filterOptions={createFilterOptions({
              matchFrom: "any",
              limit: 100,
            })}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Title"
            variant="outlined"
            required
            value={formData?.title || ""}
            onChange={(e) => onChange(e, `title`)}
            fullWidth
            inputProps={{ maxLength: 50 }}
            helperText={
              !!formErrors[`title`] ? (
                "กรุณากรอกหัวข้อบทความ"
              ) : (
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                  {formData?.title?.length}/50
                </Box>
              )
            }
            error={!!formErrors[`title`]}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Sub Title"
            variant="outlined"
            required
            value={formData?.sub_title || ""}
            onChange={(e) => onChange(e, `sub_title`)}
            fullWidth
            // multiline
            // maxRows={4}
            inputProps={{ maxLength: 100 }}
            helperText={
              !!formErrors[`sub_title`] ? (
                "กรุณากรอกหัวข้อรอง"
              ) : (
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                  {formData?.sub_title?.length}/100
                </Box>
              )
            }
            error={!!formErrors[`sub_title`]}
          />
        </Grid>

        <Grid item xs={12}>
          <FormControl error={!!formErrors[`belong_to`]} required>
            <FormLabel>Belong to</FormLabel>
            <RadioGroup
              row
              required
              aria-labelledby="demo-radio-buttons-group-label"
              // defaultValue="xsurface"
              name="radio-buttons-group"
              value={formData.belong_to || ""}
              onChange={(e) => onChange(e, `belong_to`)}
              error={!!formErrors[`belong_to`]}
              sx={{ height: "40px" }}
            >
              <FormControlLabel
                sx={{
                  color: !!formErrors[`belong_to`] ? "#d32f2f" : null,
                }}
                value="xsurface"
                control={
                  <Radio
                    sx={{ color: !!formErrors[`belong_to`] ? "#d32f2f" : null }}
                  />
                }
                label="Xsurface"
              />
              <FormControlLabel
                sx={{
                  color: !!formErrors[`belong_to`] ? "#d32f2f" : null,
                }}
                value="wallplast"
                control={
                  <Radio
                    sx={{ color: !!formErrors[`belong_to`] ? "#d32f2f" : null }}
                  />
                }
                label="Wallplast"
              />
            </RadioGroup>
            {!!formErrors[`belong_to`] && (
              <FormHelperText sx>กรุณาเลือกที่อยู่ของบล็อค</FormHelperText>
            )}
          </FormControl>
        </Grid>
      </Grid>
    </S.Container>
  );
};

export default Step1;
